module.exports = __webpack_public_path__ + "img/find-primary.1bd5f49a.svg";